import React from "react";
import { Button, Typography } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import InfoSystem from "./InfoSystem";
import { brandName } from "../../theme/tokens";

const { Text } = Typography;

const AppHeader = ({ isMobile, onToggleSidebar }: { isMobile?: boolean; onToggleSidebar?: () => void }) => {
  return (
      <div
        className="flex flex-row items-center justify-between"
        style={{
          background: '#FFFFFF',
          borderBottom: '1px solid #F0DDE3',
          padding: '0 12px',
          height: 64,
        }}
      >
        <div className="flex flex-row items-center gap-2">
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={onToggleSidebar}
            />
          )}
          <Text style={{ color: '#3A2430', fontWeight: 600 }} className="text-sm">
            {brandName}
          </Text>
        </div>
        <InfoSystem />
      </div>
  )
}

export default AppHeader